import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { PtKendoGridDirective } from '../../../../_foundation/kendo/directives/pt-kendo-grid/pt-kendo-grid.directive';
import { AppConfig } from '../../../../app/app.config';
import { KendoGridColumnConfig, KendoGridDataConfig } from '../../../../_foundation/kendo/models/grid.models';
import stageGridConfig from './project-detail-stage-grid.config';
import { State } from '@progress/kendo-data-query';
import { ProjectDetailService } from '../../../../services/setup/project-detail.service';
import { ProjectDetailLocationGridPage } from '../project-detail-location-grid/project-detail-location-grid';
import { ProjectDetailCoaGridPage } from '../project-detail-coa-grid/project-detail-coa-grid';

@IonicPage()
@Component({
  selector: 'page-project-detail-stage-grid',
  templateUrl: 'project-detail-stage-grid.html',
})
export class ProjectDetailStageGridPage {
  @ViewChild('grid') grid?: GridComponent;
  @ViewChild('ptKendoGrid') ptKendoGrid: PtKendoGridDirective;

  projectId: number;
  projectName: string;
  phaseId: number;
  phaseName: string;

  config = AppConfig.settings;
  loading: boolean = false;
  gridConfig: KendoGridColumnConfig = stageGridConfig;
  gridData: GridDataResult;
  gridDataConfig: KendoGridDataConfig;

  public state: State = {
    take: 15,
    sort: stageGridConfig.defaultSort,
  };

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private projectDetailService: ProjectDetailService) {
    this.projectId = this.navParams.get('projectId');
    this.projectName = this.navParams.get('projectName');
    this.phaseId = this.navParams.get('phaseId');
    this.phaseName = this.navParams.get('phaseName');

    this.gridDataConfig = this.projectDetailService.getStageGridDataConfig(this.phaseId);
  }

  ionViewDidLoad() {
    this.loadGrid();
  }

  private loadGrid(): void {
    if (this.ptKendoGrid) {
      this.ptKendoGrid.updateGrid().subscribe(res => {
        this.gridData = res;
      });
    }
  }

  viewLocationsGrid(row: any) {
    this.navCtrl.push(ProjectDetailLocationGridPage, {
      projectId: this.projectId,
      projectName: this.projectName,
      stageId: row.id,
      stageName: row.name});
  }

  viewCoaGrid(row: any) {
    this.navCtrl.push(ProjectDetailCoaGridPage, {
      projectId: this.projectId,
      projectName: this.projectName,
      stageId: row.id,
      stageName: row.name});
  }
}



// WEBPACK FOOTER //
// ./src/pages/setup/project-details/project-detail-stage-grid/project-detail-stage-grid.ts